import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchForms } from 'store/Forms/actions'
import AssignFormUsersModal from './AssignFormUsersModal'
import CreateEditForm from './CreateEditForm'
import CreateEditSection from './CreateEditSection'
import FormContainer from './FormContainer'
import FiltersModal from './FiltersModal'
import { deleteForm } from 'store/Forms/actions'
import SettingsModal from './SettingsModal'
import ScheduledSubmissionsModal from './ScheduledSubmissionsModal'

function AdminForms({
  searchFilter,
  showAddFormModal,
  setShowAddFormModal,
  showFiltersModal,
  setShowFiltersModal,
  setAdminFormsLength,
  setLoading,
  selectedSectionFilter,
  onSectionClick,
  autoFillFormId,
  removeFillFormFromUrl,
}) {
  const dispatch = useDispatch()

  const { forms } = useSelector((store) => store.form)
  const [showEditFormModal, setShowEditFormModal] = useState(false)
  const [showEditSectionModal, setShowEditSectionModal] = useState(false)
  const [showFormSettingsModal, setShowFormSettingsModal] = useState(false)
  const [showFormSubmissionsModal, setShowFormSubmissionsModal] =
    useState(false)
  const [formId, setFormId] = useState(null)
  const [selectedSection, setSelectedSection] = useState(null)
  const [showAssignUsersModal, setShowAssignUsersModal] = useState(false)
  const [filteredForms, setFilteredForms] = useState(forms || [])

  const deleteFormFn = (formId) => {
    const itemToDelete = forms?.find((item) => item.id === formId)
    const isSection = itemToDelete?.is_section

    const confirmMessage = isSection
      ? 'Are you sure you want to delete this section? All forms in this section will be moved to no section!'
      : 'Are you sure you want to delete this form? All its submissions will be deleted too!'

    // eslint-disable-next-line no-restricted-globals
    if (!window.confirm(confirmMessage)) {
      return
    }
    dispatch(deleteForm(formId))
    setFilteredForms(forms?.filter((form) => form.id !== formId))
  }

  const handleEditClick = (form) => {
    if (form.is_section) {
      setSelectedSection(form)
      setShowEditSectionModal(true)
    } else {
      setFormId(form.id)
      setShowEditFormModal(true)
    }
  }

  useEffect(() => {
    dispatch(fetchForms())

    return () => {
      dispatch(fetchForms())
    }
  }, [dispatch])

  // let filteredForms = forms?.filter((form) =>
  //   form?.title?.toLowerCase()?.includes(searchFilter?.toLowerCase())
  // )

  useEffect(() => {
    if (forms && forms.length) {
      let filtered = forms.filter((form) =>
        form?.title?.toLowerCase()?.includes(searchFilter?.toLowerCase())
      )

      // Apply section filter
      if (selectedSectionFilter) {
        // Show only forms and sub-sections belonging to the selected section
        filtered = filtered.filter(
          (form) => form.section_id === selectedSectionFilter
        )
      } else {
        // Show only top-level items: top-level sections and forms with no section
        filtered = filtered.filter(
          (form) => !form.section_id // This will show both top-level sections and ungrouped forms
        )
      }

      setFilteredForms(filtered)
    } else {
      setFilteredForms([])
    }
  }, [forms, searchFilter, selectedSectionFilter])

  useEffect(() => {
    if (filteredForms) setAdminFormsLength(filteredForms?.length)
  }, [filteredForms, setAdminFormsLength])

  return (
    <>
      <div className='d-flex flex-column'>
        {filteredForms && filteredForms.length
          ? filteredForms?.map((form, index) => (
              <FormContainer
                key={form.id}
                form={form}
                setShowEditFormModal={setShowEditFormModal}
                setShowAssignUsersModal={setShowAssignUsersModal}
                setShowFormSettingsModal={setShowFormSettingsModal}
                setShowFormSubmissionsModal={setShowFormSubmissionsModal}
                setFormId={setFormId}
                deleteForm={deleteFormFn}
                lastForm={index === filteredForms.length - 1}
                onSectionClick={onSectionClick}
                onEditClick={() => handleEditClick(form)}
                autoFillFormId={autoFillFormId}
                removeFillFormFromUrl={removeFillFormFromUrl}
              />
            ))
          : null}
      </div>
      {showAssignUsersModal && (
        <AssignFormUsersModal
          setShowAssignUsersModal={setShowAssignUsersModal}
          showAssignUsersModal={showAssignUsersModal}
          formId={formId}
        />
      )}
      {showFormSettingsModal && (
        <SettingsModal
          setShowModal={setShowFormSettingsModal}
          showModal={showFormSettingsModal}
          formId={formId}
        />
      )}
      {showFormSubmissionsModal && (
        <ScheduledSubmissionsModal
          setShowModal={setShowFormSubmissionsModal}
          showModal={showFormSubmissionsModal}
          formId={formId}
        />
      )}
      {showEditFormModal && (
        <CreateEditForm
          showAddFormModal={showEditFormModal}
          setShowAddFormModal={setShowEditFormModal}
          editMode={true}
          formId={formId}
        />
      )}
      {showEditSectionModal && (
        <CreateEditSection
          showModal={showEditSectionModal}
          setShowModal={setShowEditSectionModal}
          editMode={true}
          sectionId={selectedSection?.id}
          initialData={selectedSection}
        />
      )}
      {/* {showAddFormModal && (
        <CreateEditForm
          showAddFormModal={showAddFormModal}
          setShowAddFormModal={setShowAddFormModal}
        />
      )} */}
      {showFiltersModal && (
        <FiltersModal
          setShowFiltersModal={setShowFiltersModal}
          showFiltersModal={showFiltersModal}
        />
      )}
    </>
  )
}

export default AdminForms
